module.exports = __webpack_public_path__ + "videos/insight-52.e9f6603.mp4";